module.exports = __webpack_public_path__ + "img/1440.9707365b.jpg";